import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Copy, Check } from 'lucide-react';

export function CopyUri({ value, testId }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch { /* clipboard blocked */ }
  };
  return (
    <div className="flex items-center gap-2">
      <code className="flex-1 min-w-0 truncate rounded bg-background border px-2 py-1.5 text-xs" data-testid={testId}>{value}</code>
      <Button type="button" size="sm" variant="outline" onClick={copy} data-testid={`${testId}-copy`}>{copied ? <Check className="h-4 w-4 mr-1" /> : <Copy className="h-4 w-4 mr-1" />}{copied ? 'Copied' : 'Copy'}</Button>
    </div>
  );
}
